import { useQuery } from '@tanstack/react-query';
import { useReviewPreviewPageStatus, useReviewPreviewParams } from 'screens/performanceReview/hooks/reviewPreviewHooks';
import useReviewFormParams from 'screens/performanceReview/hooks/useReviewFormParams';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getPeerFeedback } from 'services/performanceReview';

const getData = async ({
  employeeId,
  reviewId,
  goalId,
  competencyId,
  questionId,
  providerType,
  isPreview,
  previewSubmissionStatus,
}) => {
  try {
    const res = await getPeerFeedback({
      goalId,
      competencyId,
      reviewId,
      employeeId,
      questionId,
      providerType,
      isPreview,
      previewSubmissionStatus,
    });
    return res;
  } catch (err) {
    console.error('Error fetching stats data for reviewId : ', reviewId, ' error : ', err);
  }
  return null;
};

const usePeerFeedbackData = ({ goalId, competencyId, questionId, isManagerView, providerType }) => {
  const { isPreview, providerType: previewResponseProviderType } = useReviewPreviewParams();
  const previewSubmissionStatus = useReviewPreviewPageStatus();

  const { employeeId, reviewId } = useReviewFormParams();
  return useQuery(
    [REACT_QUERY_KEYS.ReviewFormPeerFeedback, employeeId, reviewId, goalId, competencyId, questionId],
    () =>
      getData({
        goalId,
        competencyId,
        reviewId,
        employeeId,
        questionId,
        providerType: providerType || previewResponseProviderType,
        isPreview,
        previewSubmissionStatus,
      }),
    { enabled: isManagerView }
  );
};

export default usePeerFeedbackData;
